import { Subtitle } from '../TypographyNew';
import React, { FC } from 'react';
import { Bar, PlanUsageChart, PlanUsageContainer } from './PlanUsage.styles';
import { LegendItem, Legends } from './components/Legends';
import { PlanCurrentUsageProps, PlanPastUsageProps } from './PlanUsage.type';
import { barColors, getAbsoluteWidth, getIntervals } from './PlanUsage.utils';
import { Intervals } from './components/Intervals';
import { Marks } from './components/Marks';

export const PlanCurrentUsage: FC<PlanCurrentUsageProps> = ({
  intervals,
  forecastUsage,
  currentUsage,
}) => {
  const newIntervals = getIntervals(intervals, forecastUsage, currentUsage);

  const maxValue = newIntervals[newIntervals.length - 1].max;

  const usage = currentUsage > maxValue ? maxValue : currentUsage;
  const forecast = forecastUsage > maxValue ? maxValue : forecastUsage;

  return (
    <PlanUsageContainer>
      <Legends>
        <LegendItem color={barColors.CURRENT}>
          Current usage (<b>{currentUsage} credits</b>)
        </LegendItem>
        <LegendItem color={barColors.FORECAST}>
          Forecast usage (<b>{forecastUsage} credits*</b>)
        </LegendItem>
      </Legends>
      <PlanUsageChart>
        <Bar
          color={barColors.FORECAST}
          width={getAbsoluteWidth(forecast, maxValue)}
        />
        <Bar
          color={barColors.CURRENT}
          width={getAbsoluteWidth(usage, maxValue)}
        />

        <Intervals intervals={newIntervals} value={usage} />
        <Marks intervals={newIntervals} maxValue={maxValue} value={usage} />
      </PlanUsageChart>
    </PlanUsageContainer>
  );
};

export const PlanPastUsage: FC<PlanPastUsageProps> = ({
  intervals,
  pastUsage,
}) => {
  const newIntervals = getIntervals(intervals, pastUsage);

  const maxValue = newIntervals[newIntervals.length - 1].max;
  const past = pastUsage > maxValue ? maxValue : pastUsage;

  return (
    <PlanUsageContainer>
      <Legends>
        <LegendItem color={barColors.PAST}>Past usage ({pastUsage})</LegendItem>
      </Legends>
      <PlanUsageChart noIndicator>
        <Bar color={barColors.PAST} width={getAbsoluteWidth(past, maxValue)} />
        <Intervals intervals={newIntervals} value={past} noIndicator />
        <Marks intervals={newIntervals} maxValue={maxValue} value={past} />
      </PlanUsageChart>
    </PlanUsageContainer>
  );
};
